import React from 'react';

export interface InternalPageHeaderMetaItem {
  label: string;
  value: React.ReactNode;
}

interface InternalPageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  meta?: InternalPageHeaderMetaItem[];
}

const InternalPageHeader: React.FC<InternalPageHeaderProps> = ({
  eyebrow,
  title,
  description,
  actions,
  meta = [],
}) => {
  return (
    <section className="operator-page__header">
      <div className="operator-page__header-top">
        <div className="operator-page__intro">
          {eyebrow ? <div className="operator-page__eyebrow">{eyebrow}</div> : null}
          <h1 className="operator-page__title">{title}</h1>
          {description ? <p className="operator-page__copy">{description}</p> : null}
        </div>
        {actions ? <div className="operator-page__header-actions">{actions}</div> : null}
      </div>

      {meta.length > 0 ? (
        <div className="operator-page__meta">
          {meta.map((item) => (
            <div key={item.label} className="operator-page__meta-card">
              <span className="operator-page__meta-label">{item.label}</span>
              <strong className="operator-page__meta-value">{item.value}</strong>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default InternalPageHeader;
